document.addEventListener('DOMContentLoaded', function() {
  // =============================================================================
  // CONSTANTES ET CONFIGURATION
  // =============================================================================
  
  // Sélecteurs CSS réutilisables
  const SELECTORS = {
    // Conteneurs principaux
    customPopup: '.custom-popup-almapay',
    paymentBlock: '.payment-popup-block',
    productPriceEl: '.price--wrapper',
    modal: '.popup-modal--paiement',
    
    // Éléments de paiement
    paymentOptionsData: '.payment-options-data',
    paymentOptionData: '.payment-option-data',
    multival: '.multival',
    multivalModal: '.multival--modal',
    installementBlock: '.installement-variants-block',
    paymentImages: '.payment-images',
    
    // Images des solutions de paiement
    almaImg: '.alma-img',
    younitedImg: '.younited-img',
    
    // Modal de paiement
    modalSummary: '.popup-paiement__summary',
    modalBlock: '.popup-paiement__block',
    feesLine: '.popup-paiement__fees-line',
    
    // Éléments de prix
    complementaryPrice: '[data-complementary] input:checked + label .card--infos__price',
    
    // Boutons et déclencheurs
    savoirPlusOpener: '.en-savoir-plus-opener',
    
    // Inputs de changement
    complementaryInputs: '[data-complementary] input[type="radio"]',
    variantInputs: 'variant-selects input[type="radio"], variant-selects select',
    
    // Alma
    almaBadge: '#alma-badge, [id*="alma-badge"], .alma-badge',
    almaPaymentPlans: '.alma-payment-plans-container, [class*="alma-payment-plans"]',
    almaModal: '#alma-widget-modal-main-container, .ReactModal__Content[aria-labelledby="modal-title"]',
    almaContainer: '#payment-plans, .alma-eligibility-modal-eligibility-options',
    
    // Younited Pay
    younitedPopupZone: '#younited_popupzone',
    younitedWidgetRoot: '.younitedpay-widget-root',
    younitedTrigger: '[data-younited-trigger], .younited-trigger, [onclick*="younited"]',
    maturityInstallment: '.maturity_installment'
  };
  
  // Sélecteurs composés pour les clics
  const CLICKABLE_SELECTORS = 'button, a, [role="button"], [onclick], div[class*="payment-plans"]';
  
  // Configuration des solutions de paiement
  const PAYMENT_SOLUTIONS = {
    alma: 'alma',
    younited: 'younited-pay'
  };
  
  // Configuration des tentatives de synchronisation
  const SYNC_CONFIG = {
    alma: { maxAttempts: 20, delay: 150 },
    younited: { maxAttempts: 30, delay: 200 }
  };
  
  // Configuration du debounce
  const DEBOUNCE_DELAY = 150;
  
  // Templates par défaut pour l'affichage
  const DEFAULT_TEMPLATES = {
    withFees: 'règlement en __COUNT__ échéances (avec frais)',
    noFees: '__COUNT__ x __AMOUNT__ € (sans frais)'
  };
  
  // Événements personnalisés pour Alma
  const ALMA_EVENTS = ['alma:open', 'alma:show', 'alma:openModal', 'alma:display'];
  
  // Méthodes d'API pour les solutions de paiement
  const API_METHODS = {
    alma: ['openModal', 'showModal', 'open'],
    younited: ['openPopup']
  };
  
  // =============================================================================
  // CACHE DOM
  // =============================================================================
  
  const cache = {
    customPopup: null,
    paymentBlock: null,
    productPriceEl: null,
    modal: null,
    refresh() {
      this.customPopup = document.querySelector(SELECTORS.customPopup);
      this.paymentBlock = this.customPopup?.querySelector(SELECTORS.paymentBlock);
      this.productPriceEl = document.querySelector(SELECTORS.productPriceEl);
      this.modal = document.querySelector(SELECTORS.modal);
    }
  };
  cache.refresh();

  // =============================================================================
  // FONCTIONS UTILITAIRES
  // =============================================================================
  
  /**
   * Formate un montant en euros avec 2 décimales
   */
  const formatEuro = (n) => (Math.round(n * 100) / 100).toFixed(2);
  
  /**
   * Calcule le prix total actuel (produit + matelas si sélectionné)
   * @returns {number} Prix total en centimes
   */
  function getCurrentTotalPrice() {
    if (!cache.productPriceEl) return 0;
    
    const productPrice = parseInt(cache.productPriceEl.dataset.price) || 0;
    const priceOptionEl = document.querySelector(SELECTORS.complementaryPrice);
    const priceOption = priceOptionEl ? parseInt(priceOptionEl.dataset.price) || 0 : 0;
    
    return productPrice + priceOption;
  }

  /**
   * frais_paiement est un simple booléen (checkbox "Avec frais de paiement ?"),
   * pas un pourcentage : il peut arriver sous forme de "true"/"false" (dataset)
   * ou de booléen JS natif selon l'appelant.
   */
  function hasFees(fraisPaiement) {
    return fraisPaiement === true || fraisPaiement === 'true';
  }

  /**
   * Calcule le montant mensuel (aucun pourcentage de frais n'est configurable
   * dans le thème : le montant ne varie donc pas selon le drapeau frais)
   */
  function calculateMonthlyAmount(totalPriceCents, nombrePaiement) {
    return Math.round(totalPriceCents / nombrePaiement) / 100;
  }

  /**
   * Génère le texte d'affichage pour une option de paiement
   */
  function generateDisplayText(nombrePaiement, monthlyAmount, fraisPaiement, templates) {
    const amountStr = monthlyAmount.toFixed(2);
    const template = hasFees(fraisPaiement) ? templates.withFees : templates.noFees;

    return template
      .replace(/__COUNT__/g, nombrePaiement)
      .replace(/__AMOUNT__/g, amountStr);
  }

  /**
   * Met à jour les attributs data d'un élément
   */
  function updateDataAttributes(element, nombrePaiement, solutionPaiement, fraisPaiement) {
    element.dataset.nombrePaiement = nombrePaiement.toString();
    element.dataset.solutionPaiement = solutionPaiement;
    element.dataset.fraisPaiement = fraisPaiement.toString();
  }

  /**
   * Recalcule les montants de paiement en plusieurs fois avec le nouveau prix
   * Optimisé avec requestAnimationFrame pour les mises à jour DOM
   */
  function recalculatePaymentAmounts() {
    if (!cache.customPopup || !cache.paymentBlock) return;

    const paymentOptionsData = cache.paymentBlock.querySelector(SELECTORS.paymentOptionsData);
    if (!paymentOptionsData) return;

    const totalPriceCents = getCurrentTotalPrice();
    if (!totalPriceCents) return;
    
    const totalPriceEuros = totalPriceCents / 100;

    // Mettre à jour le prix dans les attributs data
    cache.customPopup.dataset.productPrice = totalPriceEuros.toString();
    cache.paymentBlock.dataset.productPrice = totalPriceEuros.toString();

    // Récupérer l'option de paiement actuellement sélectionnée
    const activeMultival = cache.paymentBlock.querySelector(`${SELECTORS.multival}.active`);
    const currentNombrePaiement = activeMultival ? parseInt(activeMultival.dataset.multival) : null;

    // Templates de texte pour l'affichage
    const templates = {
      withFees: cache.customPopup.dataset.i18nOptionWithFees || DEFAULT_TEMPLATES.withFees,
      noFees: cache.customPopup.dataset.i18nOptionNoFees || DEFAULT_TEMPLATES.noFees
    };

    // Recalculer tous les montants pour chaque option
    const allOptions = paymentOptionsData.querySelectorAll(SELECTORS.paymentOptionData);
    let installementBlock = null;
    let selectedSolution = PAYMENT_SOLUTIONS.alma;
    let selectedFrais = 0;

    allOptions.forEach(optionData => {
      const nombrePaiement = parseInt(optionData.dataset.multival);
      const fraisPaiement = optionData.dataset.fraisPaiement;
      const solutionPaiement = optionData.dataset.solutionPaiement || PAYMENT_SOLUTIONS.alma;

      const monthlyRounded = calculateMonthlyAmount(totalPriceCents, nombrePaiement);
      const displayText = generateDisplayText(nombrePaiement, monthlyRounded, fraisPaiement, templates);

      // Mettre à jour le contenu et les attributs data
      optionData.textContent = displayText;
      optionData.dataset.monthlyPayment = monthlyRounded.toString();

      // Si c'est l'option actuellement sélectionnée, préparer la mise à jour
      if (currentNombrePaiement && nombrePaiement === currentNombrePaiement) {
        if (!installementBlock) {
          installementBlock = cache.paymentBlock.querySelector(SELECTORS.installementBlock);
        }
        selectedSolution = solutionPaiement;
        selectedFrais = fraisPaiement;
      }
    });

    // Mise à jour batch avec requestAnimationFrame pour meilleure performance
    requestAnimationFrame(() => {
      updateMontantMaxVisibility(totalPriceEuros);

      if (installementBlock && currentNombrePaiement) {
        const optionData = paymentOptionsData.querySelector(`[data-multival="${currentNombrePaiement}"]`);
        if (optionData) {
          installementBlock.textContent = optionData.textContent.trim();
        }
      }

      if (currentNombrePaiement) {
        updateDataAttributes(cache.paymentBlock, currentNombrePaiement, selectedSolution, selectedFrais);
        updateDataAttributes(cache.customPopup, currentNombrePaiement, selectedSolution, selectedFrais);
      }

      if (cache.modal) {
        updateModalPaymentSummary(cache.modal);
      }
    });
  }

  // =============================================================================
  // FONCTIONS DE GESTION DES OPTIONS DE PAIEMENT
  // =============================================================================
  
  /**
   * Met à jour l'affichage des images de solution de paiement
   */
  function updatePaymentImages(paymentImages, solution) {
    const almaImg = paymentImages.querySelector(SELECTORS.almaImg);
    const younitedImg = paymentImages.querySelector(SELECTORS.younitedImg);
    const isAlma = solution === PAYMENT_SOLUTIONS.alma;

    if (almaImg) almaImg.style.display = isAlma ? 'block' : 'none';
    if (younitedImg) younitedImg.style.display = isAlma ? 'none' : 'block';
  }

  /**
   * Met à jour l'affichage d'une option de paiement sélectionnée
   */
  function updateSelectedPaymentOption(paymentBlock, nombrePaiement) {
    const paymentOptionsData = paymentBlock.querySelector(SELECTORS.paymentOptionsData);
    if (!paymentOptionsData) return;

    const optionData = paymentOptionsData.querySelector(`[data-multival="${nombrePaiement}"]`);
    if (!optionData) return;

    const { solutionPaiement: nouvelleSolutionPaiement, fraisPaiement: nouveauxFraisPaiement } = optionData.dataset;

    // Trouver le bloc d'installement correspondant
    const installementBlock = paymentBlock.querySelector(SELECTORS.installementBlock);
    if (installementBlock) {
      installementBlock.textContent = optionData.textContent.trim();
    }

    // Mettre à jour l'image de la solution de paiement
    const paymentImages = paymentBlock.querySelector(SELECTORS.paymentImages);
    if (paymentImages) {
      updatePaymentImages(paymentImages, nouvelleSolutionPaiement);
    }

    // Mettre à jour tous les attributs data du bloc
    updateDataAttributes(paymentBlock, nombrePaiement, nouvelleSolutionPaiement, nouveauxFraisPaiement);

    // Mettre à jour aussi le conteneur parent si nécessaire
    const customPopup = paymentBlock.closest(SELECTORS.customPopup);
    if (customPopup) {
      updateDataAttributes(customPopup, nombrePaiement, nouvelleSolutionPaiement, nouveauxFraisPaiement);
    }
  }

  /**
   * Met à jour la visibilité des options multival selon le montant minimum requis (montant_max)
   * et affiche/masque le widget entier en conséquence.
   * @param {number} totalPriceEuros - Prix total en euros (produit + matelas éventuel)
   */
  function updateMontantMaxVisibility(totalPriceEuros) {
    if (!cache.customPopup || !cache.paymentBlock) return;

    const allMultivals = cache.paymentBlock.querySelectorAll(SELECTORS.multival);
    let anyVisible = false;
    let activeIsVisible = false;
    let firstVisibleMultival = null;

    allMultivals.forEach(multival => {
      const montantMax = parseFloat(multival.dataset.montantMax) || 0;
      const isAvailable = montantMax === 0 || totalPriceEuros >= montantMax;

      multival.style.display = isAvailable ? '' : 'none';

      if (isAvailable) {
        anyVisible = true;
        if (!firstVisibleMultival) firstVisibleMultival = multival;
        if (multival.classList.contains('active')) activeIsVisible = true;
      }
    });

    // Si l'option active est maintenant masquée, basculer sur la première option visible
    if (!activeIsVisible && firstVisibleMultival) {
      handleMultivalSelection(firstVisibleMultival);
    }

    // Afficher ou masquer le widget entier
    cache.customPopup.style.display = anyVisible ? '' : 'none';
  }

  /**
   * Applique la sélection d'une option (clic ou hover)
   */
  function handleMultivalSelection(multivalElement) {
    if (!multivalElement) return;

    // Trouver le payment-popup-block parent
    const paymentBlock = multivalElement.closest(SELECTORS.paymentBlock);
    if (!paymentBlock) return;

    // Récupérer le nombre de paiements sélectionné
    const nouveauNombrePaiement = parseInt(multivalElement.dataset.multival);

    // Mettre à jour la classe active sur tous les multivals du même bloc
    const allMultivals = paymentBlock.querySelectorAll(SELECTORS.multival);
    allMultivals.forEach(multival => {
      multival.classList.remove('active');
    });
    multivalElement.classList.add('active');

    // Mettre à jour l'affichage de l'option sélectionnée
    updateSelectedPaymentOption(paymentBlock, nouveauNombrePaiement);
  }

  /**
   * Met à jour la classe active des multivals dans la modal selon la sélection actuelle.
   */
  function updateModalMultivalsActive(modal, nombrePaiement) {
    if (!modal || nombrePaiement == null) return;
    const multivals = modal.querySelectorAll(SELECTORS.multivalModal);
    multivals.forEach(m => {
      m.classList.toggle('active', parseInt(m.dataset.multival) === nombrePaiement);
    });
  }

  /**
   * Met à jour le résumé (bullets, total, frais) dans la modal selon l'option de paiement sélectionnée.
   * Utilise les mêmes calculs que le bloc principal (prix produit, frais %, montant mensuel).
   */
  function updateModalPaymentSummary(modal) {
    if (!modal || !cache.paymentBlock) return;

    const paymentOptionsData = cache.paymentBlock.querySelector(SELECTORS.paymentOptionsData);
    if (!paymentOptionsData) return;

    const productPriceEuros = parseFloat(cache.paymentBlock.dataset.productPrice) || 0;
    const selectedNombrePaiement = parseInt(cache.paymentBlock.dataset.nombrePaiement) || 0;
    const currentSolution = cache.paymentBlock.dataset.solutionPaiement || modal.getAttribute('data-current-solution') || PAYMENT_SOLUTIONS.alma;

    const optionData = paymentOptionsData.querySelector(`${SELECTORS.paymentOptionData}[data-multival="${selectedNombrePaiement}"]`);
    if (!optionData) return;

    // frais_paiement est un simple drapeau booléen (pas de pourcentage configurable
    // dans le thème), donc aucun montant de frais n'est calculable ici.
    const optionHasFees = hasFees(optionData.dataset.fraisPaiement);

    const totalEuros = productPriceEuros;
    const feesEuros = 0;
    const countRest = Math.max(0, selectedNombrePaiement - 1);

    const monthlyBase = productPriceEuros / selectedNombrePaiement;
    const firstPaymentAmount = monthlyBase;

    const visibleBlock = modal.querySelector(`${SELECTORS.modalBlock}[data-solution="${currentSolution}"]`);
    if (!visibleBlock) return;

    const summary = visibleBlock.querySelector(SELECTORS.modalSummary);
    if (!summary) return;

    // Mise à jour batch des éléments
    const updates = {
      '.popup-paiement__amount-first': formatEuro(firstPaymentAmount),
      '.popup-paiement__count-rest': countRest,
      '.popup-paiement__amount-monthly': formatEuro(monthlyBase),
      '.popup-paiement__total-value': formatEuro(totalEuros),
      '.popup-paiement__fees-value': formatEuro(feesEuros)
    };

    Object.entries(updates).forEach(([selector, value]) => {
      const element = summary.querySelector(selector);
      if (element) element.textContent = value;
    });

    const feesLine = summary.querySelector(SELECTORS.feesLine);
    if (feesLine) {
      feesLine.style.display = optionHasFees ? '' : 'none';
    }
  }

  // =============================================================================
  // GESTION DES POPUPS ALMA ET YOUNITED PAY
  // =============================================================================
  
  /**
   * Au clic sur "En savoir plus", ouvrir la popup native de la solution actuelle
   * (Alma ou Younited Pay) au lieu de la modal interne Shopify.
   * On intercepte en phase capture pour empêcher l'ouverture de la modal interne.
   */
  /**
   * Ouvre la popup native (Alma ou Younited Pay) correspondant à la solution
   * de paiement actuellement sélectionnée sur le bloc de paiement.
   */
  function openPaymentPopupForBlock(paymentBlock) {
    const solution = paymentBlock.dataset.solutionPaiement || PAYMENT_SOLUTIONS.alma;
    const nombrePaiement = parseInt(paymentBlock.dataset.nombrePaiement, 10) || null;

    if (solution === PAYMENT_SOLUTIONS.alma) {
      openAlmaPopup();
      if (nombrePaiement) {
        syncAlmaSelectedPlan(nombrePaiement);
      }
    } else if (solution === PAYMENT_SOLUTIONS.younited) {
      openYounitedPayPopup();
      if (nombrePaiement) {
        syncYounitedSelectedPlan(nombrePaiement);
      }
    }
  }

  document.addEventListener('click', function(e) {
    const savoirPlusOpener = e.target.closest(SELECTORS.savoirPlusOpener);
    if (!savoirPlusOpener) return;

    const paymentBlock = savoirPlusOpener.closest(SELECTORS.paymentBlock);
    if (!paymentBlock) return;

    // Empêcher l'ouverture de la modal interne
    e.preventDefault();
    e.stopPropagation();

    openPaymentPopupForBlock(paymentBlock);
  }, true);

  /**
   * Fonction helper pour chercher dans les shadow DOM (optimisée)
   */
  function findInShadowDOM(root, selector) {
    // Vérifier d'abord dans le DOM principal
    const elements = root.querySelectorAll(selector);
    if (elements.length > 0) return Array.from(elements);
    
    // Chercher récursivement dans les shadow roots
    const shadowElements = [];
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_ELEMENT,
      null,
      false
    );
    
    let node;
    while (node = walker.nextNode()) {
      if (node.shadowRoot) {
        const shadowResults = findInShadowDOM(node.shadowRoot, selector);
        if (shadowResults.length > 0) {
          shadowElements.push(...shadowResults);
        }
      }
    }
    
    return shadowElements;
  }

  /**
   * Tente de cliquer sur un élément s'il est visible
   */
  function tryClickIfVisible(element) {
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && element.offsetParent !== null;
  }

  /**
   * Tente d'appeler une méthode d'API si elle existe
   */
  function tryCallAPI(apiObj, methods) {
    if (!apiObj) return false;
    
    for (const method of methods) {
      if (typeof apiObj[method] === 'function') {
        apiObj[method]();
        return true;
      }
    }
    return false;
  }

  /**
   * Ouvre la popup native d'Alma (modal React Alma)
   */
  function openAlmaPopup() {
    // Méthode 1 : Badge Alma
    let almaBadge = document.querySelector(SELECTORS.almaBadge);
    
    // Si pas trouvé, chercher dans shadow DOM
    if (!almaBadge) {
      const shadowResults = findInShadowDOM(document, SELECTORS.almaBadge);
      almaBadge = shadowResults[0] || null;
    }
    
    if (almaBadge) {
      const badgeButton = almaBadge.querySelector(CLICKABLE_SELECTORS) || 
                         almaBadge.shadowRoot?.querySelector(CLICKABLE_SELECTORS);
      
      if (badgeButton) {
        badgeButton.click();
        return;
      }
      almaBadge.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      almaBadge.click();
      return;
    }
    
    // Méthode 2 : Conteneurs de plans de paiement
    const almaPaymentPlans = document.querySelector(SELECTORS.almaPaymentPlans);
    if (almaPaymentPlans) {
      const clickable = almaPaymentPlans.querySelector('button, a, [role="button"], div[class*="active"], div[class*="option"]');
      (clickable || almaPaymentPlans).click();
      return;
    }
    
    // Méthode 3 : Boutons de plans
    const almaPlanButtons = document.querySelectorAll('[aria-label*="plan de paiement"], button[aria-label*="Sélectionner"], [class*="alma-eligibility-modal-eligibility-options"] button');
    if (almaPlanButtons.length > 0) {
      almaPlanButtons[0].click();
      return;
    }
    
    // Méthode 4 : Modal existante
    const almaModal = document.querySelector(SELECTORS.almaModal);
    if (almaModal) {
      const overlay = almaModal.closest('.ReactModal__Overlay');
      if (overlay) {
        Object.assign(overlay.style, { display: 'block', visibility: 'visible' });
        overlay.classList.add('ReactModal__Overlay--after-open');
        almaModal.classList.add('ReactModal__Content--after-open');
        almaModal.querySelector('button, [tabindex="-1"]')?.focus();
        return;
      }
    }
    
    // Méthode 5 : Éléments Alma visibles
    const almaElements = document.querySelectorAll('[class*="alma"], [id*="alma"]');
    for (const element of almaElements) {
      if (tryClickIfVisible(element)) {
        const button = element.querySelector(CLICKABLE_SELECTORS);
        if (button) {
          button.click();
          return;
        }
        if (['BUTTON', 'A'].includes(element.tagName) || element.getAttribute('role') === 'button') {
          element.click();
          return;
        }
      }
    }
    
    // Méthode 6 : API globale
    if (tryCallAPI(window.Alma, API_METHODS.alma) || tryCallAPI(window.alma, API_METHODS.alma)) {
      return;
    }
    
    // Méthode 7 : Événements personnalisés
    ALMA_EVENTS.forEach(eventName => {
      document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, cancelable: true }));
    });
    
    // Méthode 8 : Data attributes
    document.querySelector('[data-alma], [data-testid*="alma"], [data-alma-action]')?.click();
  }

  /**
   * Ouvre la popup native de Younited Pay
   */
  function openYounitedPayPopup() {
    const younitedPopupZone = document.querySelector(SELECTORS.younitedPopupZone);
    const younitedWidgetRoot = document.querySelector(SELECTORS.younitedWidgetRoot);
    
    if (younitedPopupZone) {
      Object.assign(younitedPopupZone.style, {
        display: 'flex',
        visibility: 'visible',
        opacity: '1'
      });
      younitedPopupZone.classList.remove('hidden');
    }
    
    if (younitedWidgetRoot) {
      Object.assign(younitedWidgetRoot.style, {
        display: 'block',
        visibility: 'visible'
      });
    }
    
    // Essayer les APIs globales
    if (tryCallAPI(window.YounitedPay, API_METHODS.younited) ||
        tryCallAPI(window.younitedPay, API_METHODS.younited) ||
        tryCallAPI(window.YounitedPayWidget, ['open'])) {
      return;
    }
    
    // Événement personnalisé
    document.dispatchEvent(new CustomEvent('younitedpay:open', { bubbles: true }));
    
    // Bouton déclencheur
    document.querySelector(SELECTORS.younitedTrigger)?.click();
  }

  /**
   * Sélectionne dans la popup Alma le plan correspondant au nombre de paiements choisi.
   */
  function syncAlmaSelectedPlan(nombrePaiement) {
    if (!nombrePaiement) return;

    const { maxAttempts, delay } = SYNC_CONFIG.alma;

    function trySelect(attempt) {
      if (attempt > maxAttempts) return;

      const container = document.querySelector(SELECTORS.almaContainer);
      if (!container) {
        setTimeout(() => trySelect(attempt + 1), delay);
        return;
      }

      // Essayer via aria-label
      let button = container.querySelector(`button[aria-label*="plan de paiement ${nombrePaiement}x"]`);

      // Sinon, chercher par texte dans span
      if (!button) {
        const targetText = `${nombrePaiement}x`;
        button = Array.from(container.querySelectorAll('button')).find(btn => 
          btn.querySelector('span')?.textContent?.trim() === targetText
        );
      }

      if (button) {
        button.click();
      } else {
        setTimeout(() => trySelect(attempt + 1), delay);
      }
    }

    trySelect(1);
  }

  /**
   * Sélectionne dans la popup Younited Pay la maturité correspondant au nombre de paiements choisi.
   */
  function syncYounitedSelectedPlan(nombrePaiement) {
    if (!nombrePaiement) return;

    const { maxAttempts, delay } = SYNC_CONFIG.younited;

    function trySelect(attempt) {
      if (attempt > maxAttempts) return;

      const containers = [
        SELECTORS.younitedPopupZone,
        SELECTORS.younitedWidgetRoot,
        '[class*="younited"]'
      ].map(sel => document.querySelector(sel)).filter(Boolean);
      
      if (!containers.length) containers.push(document);

      // Chercher par data-maturity
      let maturityEl = null;
      for (const container of containers) {
        maturityEl = container.querySelector(`${SELECTORS.maturityInstallment}[data-maturity="${nombrePaiement}"]`);
        if (maturityEl) break;
      }

      // Chercher par texte si pas trouvé
      if (!maturityEl) {
        const targetText = `${nombrePaiement}x`;
        maturityEl = containers.reduce((found, container) => {
          if (found) return found;
          return Array.from(container.querySelectorAll(SELECTORS.maturityInstallment)).find(el => 
            el.querySelector('span[data-maturity], span.yp-select-none')?.textContent?.trim() === targetText
          );
        }, null);
      }

      if (maturityEl) {
        // Essayer plusieurs cibles de clic par ordre de priorité
        const clickTargets = [
          maturityEl.querySelector(`span[data-maturity="${nombrePaiement}"]`),
          Array.from(maturityEl.querySelectorAll('span')).find(span => 
            span.textContent?.trim() === `${nombrePaiement}x`
          ),
          maturityEl.querySelector('.blocks_maturity'),
          maturityEl
        ].filter(Boolean);

        if (clickTargets[0]) {
          clickTargets[0].click();
          return;
        }
      }

      setTimeout(() => trySelect(attempt + 1), delay);
    }

    trySelect(1);
  }

  // =============================================================================
  // GESTION DES ÉVÉNEMENTS
  // =============================================================================
  
  /**
   * Gestionnaire unifié pour les clics sur multival
   */
  function handleMultivalClick(e) {
    const multivalElement = e.target.closest(SELECTORS.multival);
    if (!multivalElement) return;

    const modal = multivalElement.closest(SELECTORS.modal);
    
    if (modal) {
      // Clic dans la modal : synchroniser avec le bloc principal
      const multivalValue = parseInt(multivalElement.dataset.multival);
      if (cache.paymentBlock) {
        const mainMultival = cache.paymentBlock.querySelector(`${SELECTORS.multival}[data-multival="${multivalValue}"]`);
        if (mainMultival) {
          handleMultivalSelection(mainMultival);
          updateModalMultivalsActive(modal, multivalValue);
          updateModalPaymentSummary(modal);
        }
      }
    } else {
      // Clic sur le bloc principal
      handleMultivalSelection(multivalElement);
    }
  }

  // Écouter les clics
  document.addEventListener('click', handleMultivalClick);

  /**
   * Clic sur le bloc de paiement (hors sélection d'option et bouton "en savoir plus"
   * lui-même) : ouvre la popup, comme un clic sur "en savoir plus".
   */
  document.addEventListener('click', function(e) {
    const paymentBlock = e.target.closest(SELECTORS.paymentBlock);
    if (!paymentBlock) return;
    if (paymentBlock.closest(SELECTORS.modal)) return;
    if (e.target.closest(SELECTORS.multival)) return;
    if (e.target.closest(SELECTORS.savoirPlusOpener)) return;

    openPaymentPopupForBlock(paymentBlock);
  });

  // Sur desktop : hover = même comportement que clic (avec debounce pour éviter les calculs excessifs)
  const hasHoverCapability = window.matchMedia?.('(hover: hover) and (pointer: fine)').matches ?? true;
  let hoverTimeout = null;
  
  if (hasHoverCapability) {
    document.addEventListener('mouseenter', function(e) {
      // En capture sur document, la cible peut être le document lui-même (pas de closest)
      if (!(e.target instanceof Element)) return;
      const multivalElement = e.target.closest(SELECTORS.multival);
      if (multivalElement && !multivalElement.closest(SELECTORS.modal)) {
        // Debounce pour éviter les calculs excessifs lors du survol rapide
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          handleMultivalSelection(multivalElement);
        }, 50);
      }
    }, true);
  }

  // =============================================================================
  // OBSERVATION DES CHANGEMENTS DE PRIX
  // =============================================================================
  
  // Vérification initiale : cas où un matelas est déjà pré-sélectionné au chargement
  updateMontantMaxVisibility(getCurrentTotalPrice() / 100);

  let lastPrice = getCurrentTotalPrice();
  let priceUpdateTimeout = null;

  /**
   * Vérifie et recalcule si le prix a changé (avec debounce)
   */
  function checkAndRecalculate() {
    clearTimeout(priceUpdateTimeout);
    priceUpdateTimeout = setTimeout(() => {
      const newPrice = getCurrentTotalPrice();
      if (newPrice !== lastPrice && newPrice > 0) {
        lastPrice = newPrice;
        recalculatePaymentAmounts();
      }
    }, DEBOUNCE_DELAY);
  }

  // Observer les changements sur le prix du produit via MutationObserver
  if (cache.productPriceEl) {
    const priceObserver = new MutationObserver(checkAndRecalculate);
    priceObserver.observe(cache.productPriceEl, {
      attributes: true,
      attributeFilter: ['data-price'],
      childList: true,
      subtree: true
    });
  }

  // Délégation d'événements pour les inputs complémentaires et variants
  document.addEventListener('change', function(e) {
    const target = e.target;
    const inputSelectors = `${SELECTORS.complementaryInputs}, ${SELECTORS.variantInputs}`;
    if (target.matches(inputSelectors)) {
      checkAndRecalculate();
    }
  });

  // Système pub/sub Shopify
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, checkAndRecalculate);
  }
});
